import React from "react";

import { Navigate, RouteObject } from "react-router-dom";

import {
  Article,
  Articles,
  ChatPage,
  NewTicket,
  Products,
  SearchArticles,
  SupportTickets,
  Ticket,
} from "pages";

export const publicRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Products />,
    index: true,
  },
  {
    path: "/kb",
    element: <Products />,
  },
  {
    path: "/kb/products",
    element: <Products />,
  },
  {
    path: "/kb/search",
    element: <SearchArticles />,
  },
  {
    path: "/kb/articles/:product/:category/*",
    element: <Article />,
  },
  {
    path: "/kb/articles/:product",
    element: <Articles />,
  },
  {
    path: "/chat",
    element: <ChatPage />,
  },
];

export const routes: RouteObject[] = [
  {
    path: "/support",
    element: <SupportTickets />,
  },
  {
    path: "/support/ticket/:id",
    element: <Ticket />,
  },
  {
    path: "/support/new-ticket/:product",
    element: <NewTicket />,
  },
  {
    path: "/support/ticket",
    element: <Navigate replace to="/support" />,
  },
  {
    path: "/support/:product",
    element: <SupportTickets />,
  },
  ...publicRoutes,
];
